// extracted by mini-css-extract-plugin
export default {"container":"ErrorWidget_container__XQjsb"};